import React, { useEffect, useState } from 'react';
import { getDocs, collection, query, where } from "firebase/firestore";
import { orderDb } from '../firebaseOrders';
import { userDb } from '../firebaseUsers'; // Import userDb
import OrderCard from './OrderCard';

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [Qntfiltered, setQntfiltered] = useState('');
  const [allOrders, setAllOrders] = useState([]);
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || "");

  const fetchOrders = async (email) => {
    const ordersRef = collection(orderDb, "orders");
    const q = query(ordersRef, where("customerDetails.email", "==", email));
    const querySnapshot = await getDocs(q);
    const ordersList = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return ordersList;
  };

  const fetchUserByUsername = async (username) => {
    const usersRef = collection(userDb, "users");
    const q = query(usersRef, where("username", "==", username));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const userData = querySnapshot.docs[0].data();
      return userData.email;
    }
    return null;
  };

  const initializeOrders = async () => {
    if (!userEmail) return;

    let ordersList = await fetchOrders(userEmail);

    if (ordersList.length === 0) {
      // No orders found with current email, attempt to find by username
      const emailFromUsername = await fetchUserByUsername(userEmail);
      if (emailFromUsername) {
        localStorage.setItem("userEmail", emailFromUsername);
        setUserEmail(emailFromUsername);
        ordersList = await fetchOrders(emailFromUsername);
      }
    }

    setOrders(ordersList);
    setAllOrders(ordersList);
  };

  const handleSearch = () => {
    if (!startDate || !endDate) {
      setOrders(allOrders);
      return;
    }
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    const filtered = allOrders.filter(order => {
      let created;
      if (order.createdAt?.toDate) {
        created = order.createdAt.toDate();
      } else if (typeof order.createdAt === 'string' || typeof order.createdAt === 'number') {
        created = new Date(order.createdAt);
      } else {
        created = new Date(); // fallback
      }
      return created >= start && created <= end;
    });
    setOrders(filtered);
    setQntfiltered(filtered.length);
  };

  useEffect(() => {
    initializeOrders();
  }, [userEmail]);

  return (
    <div style={{ padding: '1rem' }}>
      <h6>Welcome: {userEmail}</h6>

      <div style={{ marginBottom: '1rem' , marginTop:20}}>
        <label>
          Start Date:&nbsp;
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        </label>
        &nbsp;&nbsp;
        <label>
          End Date:&nbsp;
          <input style={{ marginLeft: 6 ,marginTop:5}} type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
        </label>
        &nbsp;&nbsp;
        </div>
        <div   style={{
    marginBottom: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center", // Optional, only needed if vertical centering is required
  }}>
        <button
          style={{
            backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
            color: "#f5efe3",
            borderRadius: 10,
            fontWeight: "bold",
            height: 40,
            border: "none",
            width: "100%",
            maxWidth:300,
            marginTop: 10,
            marginBottom: 10,
            fontSize: "13px",
            padding: "6px 12px",
          }}
          onClick={handleSearch}
        >
          Search
        </button>
      </div>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map(order => (
          <OrderCard key={order.id} order={order} />
        ))
      )}
    </div>
  );
};

export default OrdersPage;
